/** Reserved daily-quest activation event: iOS templates are offered by Ace and never assigned automatically. */
export const ACE_OFFER_ACTIVATION_EVENT = 'AceOffer';
export const ACE_OFFER_ACTIVATION_EVENT_HINT = 'Offered by Ace on iOS; never assigned automatically';

/**
 * Daily quest activation events: the analytics event types (funnel options) plus the reserved `AceOffer`,
 * which is reserved for daily quests and may be missing from that list.
 */
export function dailyQuestActivationEvents(eventTypes: string[] | null | undefined): string[] {
    const events = (eventTypes ?? []).filter((event, index, all) => event !== ACE_OFFER_ACTIVATION_EVENT && all.indexOf(event) === index);
    return [...events, ACE_OFFER_ACTIVATION_EVENT];
}

export function dailyQuestActivationEventHint(event: string): string | undefined {
    return event === ACE_OFFER_ACTIVATION_EVENT ? ACE_OFFER_ACTIVATION_EVENT_HINT : undefined;
}
